export default __webpack_public_path__ + "static/media/webstories.1f6f0b63.svg";